import { Link, useNavigate } from 'react-router-dom'
import { Button, EmptyState } from '@/components/ui'
import { SearchIcon } from '@/components/icons'
import { PATHS } from '@/app/router/paths'

export default function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
        background: 'var(--warm-gray)',
      }}
    >
      <EmptyState
        icon={<SearchIcon size={32} />}
        title="Deze pagina bestaat niet"
        body="Het adres dat je hebt geopend klopt niet of de pagina is verplaatst."
        action={
          <Button variant="primary" onClick={() => navigate(PATHS.root, { replace: true })}>
            Naar de startpagina
          </Button>
        }
      />
      <p style={{ position: 'fixed', bottom: 'calc(16px + var(--safe-area-bottom))' }}>
        <Link to={PATHS.legal.help} style={{ color: 'var(--soft-blue)' }}>
          Hulp nodig?
        </Link>
      </p>
    </main>
  )
}
